import { UIHeading1 } from '@cian/ui-kit';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './NewbuildingBrokerGalleryBanner.css';

interface INewbuildingBrokerGalleryBannerProps {
  isFullscreen: boolean;
  title: string;
  buttons: React.ReactNode;
}

export const NewbuildingBrokerGalleryBanner = ({
  isFullscreen,
  title,
  buttons,
}: React.PropsWithChildren<INewbuildingBrokerGalleryBannerProps>) => {
  return (
    <div
      className={cx(styles['container'], { [styles['container--fullscreen']]: isFullscreen })}
      data-testid="NewbuildingBrokerGalleryBanner"
    >
      <div className={styles['image']} />
      <div className={styles['main']}>
        <UIHeading1 textAlign="center">{title}</UIHeading1>
        <div className={styles['buttons']}>{buttons}</div>
      </div>
    </div>
  );
};
